import { Button, Divider, Flex, Form, Input, Modal } from 'antd'
import { ModalProps } from 'antd/lib'
import { useParams } from 'react-router-dom'

import { useTreatmentServiceCreateAccessRequestToEpidemiologyCaseEndpoint } from 'src/api/queries'
import { ApiError } from 'src/api/requests'
import { requiredRules } from 'src/app-constants'
import { message } from 'src/components'
import { useLocales } from 'src/locales'
import { formErrorHandler } from 'src/utils'

import { useStyles } from './styles'

type Props = {
  onCancel: () => void
} & ModalProps

export const RequestAccessModal = ({ onCancel, ...props }: Props) => {
  const { t } = useLocales()
  const { styles } = useStyles()
  const { id } = useParams()

  const [form] = Form.useForm()

  const { mutate, isPending } =
    useTreatmentServiceCreateAccessRequestToEpidemiologyCaseEndpoint({
      onError: (err: ApiError) => formErrorHandler(err.body.errors),
      onSuccess: () => {
        message.success(t('cases.succes_send_request'))
        onCancel()
      }
    })

  const onSubmit = async () => {
    const values = await form.validateFields()

    mutate({ requestBody: values, caseId: String(id) })
  }

  return (
    <Modal
      open
      centered
      title={t('cases.request_access')}
      width={520}
      maskClosable={false}
      footer={null}
      onCancel={onCancel}
      {...props}
    >
      <Form form={form} requiredMark={false} layout="vertical">
        <Form.Item
          name="reason"
          label={t('cases.request_reason')}
          rules={requiredRules}
        >
          <Input.TextArea
            className={styles.caseTextarea}
            placeholder={t('cases.request_reason')}
          />
        </Form.Item>
      </Form>

      <Divider />

      <Flex justify="center" gap={8}>
        <Button onClick={onCancel}>{t('common.cancel')}</Button>
        <Button type="primary" onClick={onSubmit} loading={isPending}>
          {t('cases.send_request')}
        </Button>
      </Flex>
    </Modal>
  )
}
